export const getAppCountMessage = (count) => {
    if (count === 0)  return "noAppointment"
    if (count === 1)  return "oneAppointmentBooked"
    return "multipleAppointmentsBooked"
}